import { Component, OnInit, Input, AfterContentInit } from '@angular/core';
import { SvcServices } from 'app/services/svc.service';
import { popupService } from "app/services/popup.service";
import { PopupModalService } from 'app/services/popup-modal.service';
import { GuidService } from 'app/services/guid.service';
import { ContentService } from '../../../../services';
import { Params} from '@angular/router';

@Component({
  selector: 'popup-site-disclosure-tnc',
  templateUrl: './popup-site-disclosure-tnc.component.html',

})
export class PopupSiteDisclosureTncComponent implements OnInit {
  
  ariaTitleId: string;
  ariaBodyId: string;
  ariaDescribedBy: string;
  disclosureTncAction: string;
  disclosureTncCopy1: string;
  disclosureTncCopy2: string;
  disclosureTncCopy3: string;
  disclosureTncCopy4: string;
  disclosureTncCopy5: string;
  disclosureTncHeadline: string;
  disclosureCloseDialogADA: string;
  _params: any;
  @Input('params') set params(value) {
    this._params = value;
  }
  constructor(private popupModalService: PopupModalService,
              private _svcService: SvcServices,
              private guidService: GuidService) { }

  ngOnInit() {
    if (this._params && this._params.disclosureTncAction) {
      this.disclosureTncAction = this._params.disclosureTncAction;
    } else {
      this.disclosureTncAction = "";
    }

    if (this._params && this._params.disclosureTncHeadline) {
      this.disclosureTncHeadline = this._params.disclosureTncHeadline;
    } else {
      this.disclosureTncHeadline = "";
    }
    if (this._params && this._params.disclosureTncCopy1) {
      this.disclosureTncCopy1 = this._params.disclosureTncCopy1;
    } else {
      this.disclosureTncCopy1 = "";
    }
    if (this._params && this._params.disclosureTncCopy2) {
      this.disclosureTncCopy2 = this._params.disclosureTncCopy2;
    } else {
      this.disclosureTncCopy2 = "";
    }
    if (this._params && this._params.disclosureTncCopy3) {
      this.disclosureTncCopy3 = this._params.disclosureTncCopy3;
    } else {
      this.disclosureTncCopy3 = "";
    }
    if (this._params && this._params.disclosureTncCopy4) {
      this.disclosureTncCopy4 = this._params.disclosureTncCopy4;
    } else {
      this.disclosureTncCopy4 = "";
    }
    if (this._params && this._params.disclosureTncCopy5) {
      this.disclosureTncCopy5 = this._params.disclosureTncCopy5;
    } else {
      this.disclosureTncCopy5 = "";
    }
    if (this._params && this._params.disclosureCloseDialogADA) {
      this.disclosureCloseDialogADA = this._params.disclosureCloseDialogADA;
    } else {
      this.disclosureCloseDialogADA = "";
    }
  }

  ngAfterContentInit() {
    /* all aria required ids must be unique to keep screen reader from finding another instance of this component */
    this.ariaTitleId = this.guidService.getSimpleGuid();
    this.ariaBodyId = this.guidService.getSimpleGuid();
    
    // space separated string of all aria ids that are announced on open
    this.ariaDescribedBy = this.ariaTitleId + ' ' + this.ariaBodyId;
    
  }
  close() {
      this.popupModalService.closePopupContent.emit(null);
      this._svcService.scrollLocked.emit(false);
    }
}
